const { billetType } = require('@transfeeradev/api-enums');
const SimpleBarcode = require('./SimpleBarcode');
const CollectionBarcode = require('./CollectionBarcode');
const GetTypeService = require('../services/GetTypeService');

class Barcode {
  constructor(billet) {
    this._billet = billet;
    this._type = GetTypeService.get(this._billet.barcode);
  }

  validate() {
    if (this._type === billetType.SIMPLE) {
      return new SimpleBarcode(this._billet).validate();
    }

    return new CollectionBarcode(this._billet).validate();
  }

  getData() {
    if (this._type === billetType.SIMPLE) {
      return new SimpleBarcode(this._billet).getData();
    }

    return new CollectionBarcode(this._billet).getData();
  }
}

module.exports = Barcode;
